import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Porcentaje FSP"),
  /*#__PURE__*/_createElementVNode("th", null, "Deducción FSP"),
  /*#__PURE__*/_createElementVNode("th", null, "Porcentaje fondo subsistencia"),
  /*#__PURE__*/_createElementVNode("th", null, "Deducción fondo subsistencia")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.SolidarityPensionPercentage.$error }]),
            onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.SolidarityPensionPercentage.$touch())),
            modelValue: $setup.fondoSP.SolidarityPensionPercentage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.fondoSP.SolidarityPensionPercentage) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SolidarityPensionDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.SolidarityPensionDeduction.$touch())),
            modelValue: $setup.fondoSP.SolidarityPensionDeduction,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.fondoSP.SolidarityPensionDeduction) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "percent",
            prefix: "%",
            mode: "decimal",
            maxFractionDigits: 2,
            class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.SubsistencePercentage.$error }]),
            onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.SubsistencePercentage.$touch())),
            modelValue: $setup.fondoSP.SubsistencePercentage,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.fondoSP.SubsistencePercentage) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SubsistenceDeduction.$error }]),
            maxFractionDigits: 0,
            onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.v$.SubsistenceDeduction.$touch())),
            modelValue: $setup.fondoSP.SubsistenceDeduction,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.fondoSP.SubsistenceDeduction) = $event))
          }, null, 8, ["modelValue", "class"])
        ])
      ]),
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SolidarityPensionPercentage.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SolidarityPensionPercentage.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SolidarityPensionDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SolidarityPensionDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SubsistencePercentage.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SubsistencePercentage.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SubsistenceDeduction.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.SubsistenceDeduction.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}